// @generated by protoc-gen-es v2.2.3 with parameter "target=ts"
// @generated from file ProcedureCoordPoints.proto (package ProcedureCoordPoints, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv1";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";
import { file_google_protobuf_wrappers } from "@bufbuild/protobuf/wkt";
import type { CoordPoint } from "./CoordPoint_pb";
import { file_CoordPoint } from "./CoordPoint_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file ProcedureCoordPoints.proto.
 */
export const file_ProcedureCoordPoints: GenFile = /*@__PURE__*/
  fileDesc("ChpQcm9jZWR1cmVDb29yZFBvaW50cy5wcm90bxIUUHJvY2VkdXJlQ29vcmRQb2ludHMigAMKFFByb2NlZHVyZUNvb3JkUG9pbnRzEioKCmNvb3JkUG9pbnQYASABKAsyFi5Db29yZFBvaW50LkNvb3JkUG9pbnQSMwoTcHJvY2VkdXJlQ29vcmRQb2ludBgCIAEoCzIWLkNvb3JkUG9pbnQuQ29vcmRQb2ludBIuCghhbHRpdHVkZRgDIAEoCzIcLmdvb2dsZS5wcm90b2J1Zi5Eb3VibGVWYWx1ZRInCgJpZBgEIAEoCzIbLmdvb2dsZS5wcm90b2J1Zi5JbnQzMlZhbHVlEjoKFXByb2NlZHVyZUNvb3JkUG9pbnRQaxgFIAEoCzIbLmdvb2dsZS5wcm90b2J1Zi5JbnQzMlZhbHVlEj0KF3Byb2NlZHVyZWNvb3JkcG9pbnR0eXBlGAYgASgLMhwuZ29vZ2xlLnByb3RvYnVmLlN0cmluZ1ZhbHVlEjMKDnNlcXVlbmNlbnVtYmVyGAcgASgLMhsuZ29vZ2xlLnByb3RvYnVmLkludDMyVmFsdWVCSgotY29tLmdtdi5kZW1ldGVyLm5hdmFpZHMubW9kZWwucHJvdG8uZ2VuZXJhdGVkQhlQcm9jZWR1cmVDb29yZFBvaW50c1Byb3RvYgZwcm90bzM", [file_google_protobuf_wrappers, file_CoordPoint]);

/**
 * @generated from message ProcedureCoordPoints.ProcedureCoordPoints
 */
export type ProcedureCoordPoints = Message<"ProcedureCoordPoints.ProcedureCoordPoints"> & {
  /**
   * @generated from field: CoordPoint.CoordPoint coordPoint = 1;
   */
  coordPoint?: CoordPoint;

  /**
   * @generated from field: CoordPoint.CoordPoint procedureCoordPoint = 2;
   */
  procedureCoordPoint?: CoordPoint;

  /**
   * @generated from field: google.protobuf.DoubleValue altitude = 3;
   */
  altitude?: number;

  /**
   * @generated from field: google.protobuf.Int32Value id = 4;
   */
  id?: number;

  /**
   * @generated from field: google.protobuf.Int32Value procedureCoordPointPk = 5;
   */
  procedureCoordPointPk?: number;

  /**
   * @generated from field: google.protobuf.StringValue procedurecoordpointtype = 6;
   */
  procedurecoordpointtype?: string;

  /**
   * @generated from field: google.protobuf.Int32Value sequencenumber = 7;
   */
  sequencenumber?: number;
};

/**
 * Describes the message ProcedureCoordPoints.ProcedureCoordPoints.
 * Use `create(ProcedureCoordPointsSchema)` to create a new message.
 */
export const ProcedureCoordPointsSchema: GenMessage<ProcedureCoordPoints> = /*@__PURE__*/
  messageDesc(file_ProcedureCoordPoints, 0);

